import { Typography } from '@frontierag/frontier-ui-library';

export default function MultiAccountNotification({ title, description }) {
  return (
    <>
      <Typography variant="label1" component="div">
        {title}
      </Typography>
      <Typography variant="label2">{description}</Typography>
    </>
  );
}
